import { reviewedConversation } from '@/services/conversations-service/conversations-service';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface useReviewedCallProps {
  analytics_call_id: string;
}

export const useReviewedCall = ({ analytics_call_id }: useReviewedCallProps) => {
  const queryClient = useQueryClient();

  const { mutate: checkCall } = useMutation({
    mutationFn: (reviewed: boolean) => reviewedConversation({ analytics_call_id }, reviewed),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ReactQueryKeys.CONVERSATIONS_REVIEWED({ analytics_call_id }),
      });

      queryClient.invalidateQueries({
        queryKey: ReactQueryKeys.CONVERSATIONS({ analytics_call_id }),
      });

      queryClient.invalidateQueries({
        queryKey: ['call-log'],
      });
    },
  });

  return { checkCall };
};
